class Errors {
  constructor() {
    this.errors = {};
  }

  has (field) {
    return !!this.errors[field];
  }

  any() {
    return Object.keys(this.errors).length > 0;
  }

  get (field) {
    if (this.errors[field]) {
      const err = this.errors[field][0];
      return err.charAt(0) + err.slice(1).toLowerCase();
    }

    return null;
  }

  record (errors) {
    this.errors = errors;
  }

  clear (field) {
    if (field) {
      delete this.errors[field];
      return;
    }

    this.errors = {};
  }
}

const errors = new Errors();

export default errors;
